<template>
<div class="page_photo">
	<div class="trandsman" :style="!hideText ? 'opacity:1' : 'opacity:0'">
        <div class="info">
            <img v-if="info" :src="info.thumb ? ($publicData.withHttpStart(info.thumb) ? info.thumb : imageUrl+info.thumb) : $publicData.defaultTouxiang" alt="" class="logo" />
            <span class="name" v-if="info.nickname">{{info.nickname}}</span>
        </div>
        <div class="action">
            <div class="guanzhu" @click="attentionClickFun">{{info.is_attention==1?'已关注':'关注'}}</div>
            <!-- <img :src="publicPath+'statics/images/tuji/share.png'" alt="" class="share" v-if="isClient"/> -->
        </div>
    </div>
	<van-swipe class="my-swipe" ref="swipeDom"  @change="onChange">
		<van-swipe-item v-for="(item,i) in photo" :key="i" @click="onClickItem(i)">
			<van-image :src="imageUrl+item.thumb" width="100%" height="100vh" fit="contain" />
		</van-swipe-item>
		<template #indicator>
            <div class="custom-indicator"></div>
		</template>
	</van-swipe>
    <div class="bottom" :style="!hideText ? 'opacity:1' : 'opacity:0'">
        <template >
			<div class="custom-indicator" style="display:flex;justify-content: center;">
				<div v-for="(item,i) in indicator_photo" :key="i" >
					<van-image :class="(showItem.showIndex==0?i==0:i==1)  ? 'active default' : 'default'" width="1rem" height="1rem" style="margin-left:0.2rem;margin-right:0.2rem;" :src="imageUrl+item.thumb" @click="swipeToItem(item)" />
				</div>
			</div>
		</template>
        <div>
            <div class="top">
                <div class="time">{{showItem.time}}</div>
                <div class="time" v-if="showItem.cate_name">【{{showItem.cate_name}}】</div>
            </div>
            <div class="desc">{{showItem.content}}</div>
        </div>
        <div class="action_back">
            <div class="action_button" @click="like">
                <img class="img" :src="publicPath+(showItem.is_help>0?'statics/images/tuji/zan_done.png':'statics/images/tuji/zan_none.png')"/>
                <div class="text">{{showItem.help_num}}</div>
            </div>
            <div class="action_button" @click="getComment">
                <img class="img" :src="publicPath+'statics/images/tuji/pinglun.png'"/>
                <div class="text">{{showItem.comment_num}}</div>
            </div>
        </div>
    </div>
    <van-popup v-model="showComment" position="bottom" round :style="{ height: '50%' }">
        <div class="comment_back">
            <div class="comment_text">评论（{{showItem.comment_num}}）</div>
            <div class="con" v-for="(item,index) in commentList" :key="index">
                <div class="con_top clearfix">
                    <div class="f-l thumb">
                        <img :src="item.userthumb ? ( $publicData.withHttpStart(item.userthumb) ? item.userthumb : imageUrl+item.userthumb): $publicData.defaultTouxiang" alt="" class="thumb" />
                    </div>
                    <div class="f-l con_top_r">
                        <span class="user_name">{{ item.nickname?item.nickname:''}}</span>
                        <span class="time">{{ item.created_at }}</span>
                    </div>
                </div>
                <div class="con_nr">
                    <div class="yiji_txt" @click="toCommentSec(item)">{{ item.content }}</div>
                    <!-- 二级回复 -->
                    <div class="huifu" v-if="item.second_num != 0">
                        <div class="item clearfix" v-for="huifu in (item.show_more_second ? item.scomment.slice(0,limited_num) : item.scomment)" :key="huifu.id">
                            <div class="user_name f-l" v-if="huifu">
                                <span class="name">{{ (huifu.nickname ? huifu.nickname:'用户') + "：" }}</span>
                                {{ huifu.content }}
                            </div>
                        </div>
                        <div class="total item" v-if="item.show_more_second" @click="secondMore(item,index)">共有{{item.second_num}}条回复&nbsp;&gt;</div>
                    </div>
                </div>
            </div>
            <div class="pinglun">
                <div class="filed">
                    <van-field v-model="content" :placeholder="placeholder" ref="field"  @blur="endComment"/>
                </div>
                <div class="action" @click="toComment">评论</div>
            </div>
        </div>
    </van-popup>
    <van-image-preview v-model="showImage" :images="attrImages" :start-position="position" ref="attrPreView">
    </van-image-preview>
</div>
</template>

<script>
import router from "../../../.././router";
import {
    LOGOUT,
    LOGIN
} from "../../../.././vuex/mutation_types";
import Vue from 'vue';
import Bridge from '../../../.././vuex/bridge.js'
import { Toast } from 'vant';
Vue.prototype.$bridge = Bridge
var userAgent = navigator.userAgent

export default {
    name: "my-index",
    data() {
        return {
			imageUrl: this.$publicData.uploadImage,
            publicPath: process.env.BASE_URL,
            tradesmanId: this.$route.query.tradesmanId,
            id: this.$route.query.id,
            index: this.$route.query.index?this.$route.query.index:0,
            info: {}, // 用户信息
            photo: [],
			token:null,
			shareConfig: null, // 分享的相关配置
			current: 0,
            showItem: {
                time: '',
                cate_name: '',
                content: '',
                help_num: 0,
                comment_num: 0
            },
            showIndex: 0,
            pages: {
                page: 1,
                size: 10,
            },
			hideText: false,
            showComment: false,
            commentList: [],
            content: null,
            commentItem: null,
            placeholder: '请输入评论内容',
            limited_num: 3, // 二级评论隐藏条数限制
            indicator_photo: [],
            isSendingMessage: false,
            showImage: false,
            attrImages: [],
            position: 0,
            isClient: false
        };
    },
    created: function () {
        var that = this
        //根据userAgent判断是否在iOSAndroid客户端中
        if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
            this.isClient = true
            var params = {
                'data':
                {
                    'naviTitle':'匠人图集',
                    'rightStyle': 'share'
                }
            }
            this.$bridge.callhandler('sdjy://navigation/style', params, (data) => {

            })
            var memberParams = {
                'data': {
					notCallLogin: 1,
                }
            }
            //加载用户信息
            this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
                console.log(data)
                if (data.code == 200) {
                    this.token = data.result.token
                    this.getData()
                } else {
                    this.token = ''
                    this.getData()
                }
            })
            //注册方法，客户端重新进入页面刷新数据
            this.$bridge.registerhandler('sdjy://common/refreshPage', (data, responseCallback) => {
                // alert(JSON.stringify(data));
                responseCallback('refresh success')
            })
            //注册方法，客户端重新进入页面刷新数据
            this.$bridge.registerhandler('sdjy://common/rightButtonAction', (data, responseCallback) => {
                // alert(JSON.stringify(data));
                console.log('sdjy://common/rightButtonAction')
                const url = location.href.split('#')[0];
                var params = {
                    data: {
                        title: that.info.nickname ? that.info.nickname : that.$publicData.shareDefaultTitleA,
                        detail: that.showItem.content?that.showItem.content:'',
                        url: url,
                        platFormType:'',
                        image: that.showItem.thumb?(that.$publicData.domain + that.showItem.thumb):(that.$publicData.domain + that.$publicData.shareDefaultIcon)
                    },
                };
                this.$bridge.callhandler('sdjy://public/share', params, (data) => {

                })

            })
        } else {
            this.isClient = false
            // 获取列表
            this.token = this.$store.getters.token
            this.getData();
        }
    },
    mounted: function() {
        
    },
    methods: {
        getData() {
            this.getDetail()
            this.getTradesmanDetail()
        },
        getDetail() {
            var that = this
            var param = {
                token: this.token,
                tradesman_id: this.tradesmanId
            }
            this.$api.tradesman.photoDetail(param).then(res=>{
                if (res.code == 200) {
                    var photo = res.result
					that.photo = photo
                    var attrImages = []
                    for (let i = 0; i < that.photo.length; i++) {
                        const item = that.photo[i];
                        item.showIndex = i
                        if (parseInt(item.thumb_id) == parseInt(that.id) && parseInt(item.index) == parseInt(that.index)) {
                            that.showItem = item
                            that.$refs.swipeDom.swipeTo(i)
                            that.resetIndicatorPhoto(i)
                            // break
                        }
                        attrImages.push(this.imageUrl+item.thumb)
                    }
                    that.attrImages = attrImages
                    if (!that.showItem.thumb_id) {
                        if (photo.length > 0) {
                            that.showItem = photo[0]
                            that.resetIndicatorPhoto(0)
                        }
                    }
					// 调起 获取微信分享参数函数
					this.getShareData()
                } else {
                    this.$toast(res.message)
                }
            })
		},
        resetIndicatorPhoto(index) {
            this.indicator_photo = []
            if (index > 0) {
                this.indicator_photo.push(this.photo[index-1])
            }
            this.indicator_photo.push(this.photo[index])
            if (index != this.photo.length-1) {
                this.indicator_photo.push(this.photo[index+1])
            }
        },
        getTradesmanDetail() {
            var param = {
                token: this.token,
                tradesman_id: this.tradesmanId
            }
            this.$api.tradesman.detail(param).then(res => {
                if (res.code == 200) {
                    var info = res.result
					this.info = info
                } else {
                    this.$toast(res.message)
                }
            })
        },
        like() {
            if (userAgent && userAgent.indexOf("shidaijiyi") != -1) {
				//获取用户信息
				var memberParams = {
					data: {},
				};
				this.$bridge.callhandler(
					"sdjy://member/memberInfo",
					memberParams,
					(data) => {
						if (data.code == 200) {
							this.token = data.result.token;
							this.likeClick();
						}
					}
				);
			} else {
				// console.log('对App和H5做判断')
				this.likeClick();
			}
        },
        likeClick() {
            var that = this
            var param = {
                token: this.token,
                thumb_id: this.showItem.thumb_id,
            }
            this.$api.tradesman.photoLike(param).then(res => {
                if (res.code == 200) {
                    Toast(res.message)
                    that.getDetail()
                } else {
                    this.$toast(res.message)
                }
            })
        },
        // 关注匠人对app和h5进行判断
		attentionClickFun(){
			if (userAgent && userAgent.indexOf("shidaijiyi") != -1) {
				//获取用户信息
				var memberParams = {
					data: {},
				};
				this.$bridge.callhandler(
					"sdjy://member/memberInfo",
					memberParams,
					(data) => {
						if (data.code == 200) {
							this.token = data.result.token;
							this.attentionClick();
						}
					}
				);
			} else {
				// console.log('对App和H5做判断')
				this.attentionClick();
			}
		},
		// 关注匠人
        attentionClick() {
            var type = 1
            if (this.info.is_attention == 1) {
                type = 2
            }
            var params = {
                token: this.token,
                tradesman_id: this.tradesmanId,
                type: type
            }
            console.log(params)
            this.$api.tradesman.attention(params).then(res => {
                if (res.code == 200) {
                    if (this.info.is_attention == 1) {
                        this.$toast('取消关注成功')
                    } else {
                        this.$toast('关注成功')
                    }
                    this.getTradesmanDetail()
                } else {
                    this.$toast(res.message)
                }
            })
        },
        getComment() {
            var that = this
            var param = {
                token: this.token,
                thumb_id: this.showItem.thumb_id,
                page: this.pages.page,
                size: this.pages.size
            }
            this.$api.tradesman.photoCommentList(param).then(res => {
                if (res.code == 200) {
                    var commentList = res.result
					for(var i in commentList){
						var second = commentList[i].scomment
						if(second && second.length != 0){
							commentList[i].second_num = second.length
							if(second.length > that.limited_num){
								commentList[i].show_more_second = true
							}else{
								commentList[i].show_more_second = false
							}
						}else{
							commentList[i].second_num = 0
						}
					}
					this.commentList = commentList
                    this.showComment = true
                } else {
                    this.$toast(res.message)
                }
            })
        },
        toComment() {
            if (userAgent && userAgent.indexOf("shidaijiyi") != -1) {
				//获取用户信息
				var memberParams = {
					data: {},
				};
				this.$bridge.callhandler(
					"sdjy://member/memberInfo",
					memberParams,
					(data) => {
						if (data.code == 200) {
							this.token = data.result.token;
							this.toCommentClick();
						}
					}
				);
			} else {
				// console.log('对App和H5做判断')
				this.toCommentClick();
			}
        },
        toCommentClick() {
            var that = this
            if (!this.content || this.content == undefined || this.content == '') {
                Toast('请输入评论内容')
                return
            }
            if (this.isSendingMessage == true) {
                return
            }
            this.isSendingMessage = true
            var param = {
                token: this.token,
                thumb_id: this.showItem.thumb_id,
                content: this.content,
                attr: []
            }
            if (this.commentItem) {
                param.pid = this.commentItem.id
            }
            // return
            this.$api.tradesman.photoComment(param).then(res => {
                if (res.code == 200) {
                    Toast('评论成功')
                    that.getComment()
                    that.getDetail()
                    that.content = null
                    that.commentItem = null
                } else {
                    this.$toast(res.message)
                }
                setTimeout(() => {
                    this.isSendingMessage = false
                }, 1000);
            })
        },
        toCommentSec(item) {
            var that = this
			that.pinglun_status = true
			that.$refs.field.focus()
            that.commentItem = item
            console.log('that.commentItem:',that.commentItem)
            that.placeholder = '回复：' + (item.nickname ? item.nickname : '')
        },
        endComment() {
            console.log('endComment')
            var that = this
            setTimeout(() => {
                that.commentItem = null
            }, 100);
            
            that.placeholder = '请输入评论内容'
        },
        secondMore(item,index) {
			item.show_more_second = !item.show_more_second
			this.$set(this.commentArr,index,item)
		},
		// 获取分享参数 -- 用于配微信分享
        getShareData() {
			const url = location.href.split('#')[0];
			console.log('url', url)
            this.$api.index.commonShare({ url: url }).then(res => {
                if (res.code == 200) {
                    this.shareConfig = res.result
                    // console.log('this.shareConfig', this.shareConfig)
					// console.log('this.$route', this.$route)
					this.shareFun()
                }
            })
		},
		// 分享
        shareFun() {
			var that = this
            var item = this.showItem

            wx.config({
                debug: that.shareConfig.debug,
                beta: that.shareConfig.beta,
                jsApiList: that.shareConfig.jsApiList,
                appId: that.shareConfig.appId,
                nonceStr: that.shareConfig.nonceStr, // 随机串
                timestamp: parseInt(that.shareConfig.timestamp), // 时间戳
                signature: that.shareConfig.signature // 签名
			});
            // 分享
            wx.ready(function () {
				const url = location.href.split('#')[0];
				var shareData = {
					title: that.info.nickname ? that.info.nickname : that.$publicData.shareDefaultTitleA, // 分享标题
					desc: that.showItem.content?that.showItem.content:'', // 分享描述
					link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
					imgUrl: item.thumb ? that.$publicData.imageUrl + item.thumb : that.$publicData.domain + that.$publicData.shareDefaultIcon, // 分享图标
					success: function () {
						// 用户确认分享后执行的回调函数
						// alert('成功')
					},
					cancel: function (e) {
						// alert(e)
						// 用户取消分享后执行的回调函数
					}
				}
                wx.updateAppMessageShareData(shareData);
                wx.updateTimelineShareData(shareData);
            });
        },
		// 切换
		onChange(index) {
			this.current = index;
            this.showItem = this.photo[index]
            this.id = this.showItem.thumb_id
            this.index = this.showItem.index
			this.hideText = false;
            this.resetIndicatorPhoto(index)
		},
		// 点击
		onClickItem(index){
			// this.hideText = !this.hideText;
            this.showImage = true
            this.position = index
		},
		// 点选指示器
		swipeToItem(item){
            for (let i = 0; i < this.photo.length; i++) {
                const p = this.photo[i];
                if (item.thumb_id == p.thumb_id && item.index == p.index) {
                    this.$refs.swipeDom.swipeTo(i)
                    break
                }
            }
		}
    }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
    .custom-indicator {
        margin-top: 0.26rem;
    }
	.custom-indicator .van-image.active{
		transform: scale(1.2);
        border:2px solid white;
        border-radius: 4px;
	}
</style>
